module.exports = __webpack_public_path__ + "img/how_we_can_partner.04c8d490.jpg";